import OtherAssessmentsDialog from './OtherAssessmentsDialog';

export default OtherAssessmentsDialog;
